// @flow

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

// Selectors
import datatable from '../datatable'
import tableOperation$ from '../selectors/tableOperation'
import tableOperations$ from '../selectors/tableOperations'
import importJobsToolOperations$ from '../selectors/importJobsToolOperations'
import importJobsPopupOperations$ from '../selectors/importJobsPopupOperations'
import reopenJobOperation$ from '../selectors/reopenJobOperation'
import { authenticatedUser$ } from 'fc-authenticated-user'
import fieldSelectorOptions$ from 'hfty-assets-dom/src/selectors/fieldSelectorOptions'
import userSelectorOptions$ from 'hfty-users-dom/src/selectors/userSelectorOptions'
import { subfields$ } from 'fc-assets'
import { token$ } from 'fc-auth'
import { seasonSelectorOptions$, selectedSeasonId$ } from 'hfty-seasons'

// Filtering
import {
  jobs$,
  jobFilters$,
  filterJobsByAssignedTo,
  jobStatusSelectorOptions,
  filterJobsByStatus,
  filterJobsByDateRange,
  filterJobsBySeason,
} from 'hfty-soil-jobs'

// Operator
import tableOperator from '../tableOperator'
import importJobsToolOperator from 'hfty-operator-import-jobs-tool'
import importJobsPopupOperator from 'hfty-operator-import-jobs-popup'
import reopenJobOperator from 'hfty-operator-reopen-job'

// Action Creator
import { addTableSoilJob, editTableSoilJob, deleteTableSoilJob } from '../actions'
import { showImportJobsTool, showImportJobsPopup } from 'hfty-import-jobs-tool-dom'
import { reopenJob } from 'hfty-reopen-job-dom'
import { preselectedJob } from 'hfty-map-dom'


// State -> Props
type Props = {
  selectedIds: Array<number>,
}

function mapStateToProps (state: Object): Props {
  return {
    selectedIds: datatable.selectors.selectedRecordIds$(state),
    operation: tableOperation$(state),
    operations: tableOperations$(state),
    importJobsToolOperations: importJobsToolOperations$(state),
    importJobsPopupOperations: importJobsPopupOperations$(state),
    reopenJobOperation: reopenJobOperation$(state),
    authenticatedUser: authenticatedUser$(state),
    fieldSelectorOptions: fieldSelectorOptions$(state),
    userSelectorOptions: userSelectorOptions$(state),
    subfields: subfields$(state),
    jobStatusOptions: jobStatusSelectorOptions(),
    jobFilters: jobFilters$(state),
    token: token$(state),
    jobs: jobs$(state),
    seasonSelectorOptions: seasonSelectorOptions$(state),
    selectedSeasonId: selectedSeasonId$(state),
  }
}

type MapDispatchToProps = {
  actions: {
    onAdd: Function,
    onEdit: Function,
    showImportJobsTool: Function,
    onFilterByStatus: Function,
    onFilterByAssignedTo: Function,
    onFilterByDateRange: Function,
    reopenJob: Function,
    preselectedJob: Function,
  }
}

function mapDispatchToProps (dispatch: Dispatch<*>): MapDispatchToProps {
  return {
    actions: bindActionCreators({
      onAdd: addTableSoilJob,
      onEdit: editTableSoilJob,
      onDelete: deleteTableSoilJob,
      reopenJob,
      onChangeOperation: tableOperator.actionCreators.updateOperation,
      onCancelOperations: tableOperator.actionCreators.cancelOperations,
      onSubmitOperations: tableOperator.actionCreators.submitOperations,
      onFilterByStatus: filterJobsByStatus,
      onFilterByAssignedTo: filterJobsByAssignedTo,
      onFilterByDateRange: filterJobsByDateRange,
      onFilterBySeason: filterJobsBySeason,
      showImportJobsTool: showImportJobsTool,
      showImportJobsPopup: showImportJobsPopup,
      updateImportJobsToolOperation: importJobsToolOperator.actionCreators.updateOperation,
      onSubmitImportJobsToolOperations: importJobsToolOperator.actionCreators.submitOperations,
      onCancelImportJobsToolOperations: importJobsToolOperator.actionCreators.cancelOperations,
      onCancelImportJobsPopupOperations: importJobsPopupOperator.actionCreators.cancelOperations,
      onChangeReopenJobOperations: reopenJobOperator.actionCreators.updateOperation,
      onSubmitReopenJobOperations: reopenJobOperator.actionCreators.submitOperations,
      onCancelReopenJobOperations: reopenJobOperator.actionCreators.cancelOperations,
      preselectedJob,
    }, dispatch),
  }
}

// Export
export default connect(mapStateToProps, mapDispatchToProps)
